import React, { useEffect, useCallback, useState} from 'react';
import ParameterBox from 'components/instruments/ParameterBox.js';
import {connect} from 'react-redux';

const MicroOffsetControl = ({effect, note}) => { 
    let [parameter, setParameter] = useState(effect.offsets[note]);

    const onClick = useCallback(() => {
        if (parameter) {
            return;
        }
        setParameter(effect.newNoteOffset(note, 0));
    }, [parameter, setParameter, note]);

    if (!parameter) {
        return (
            <div
              onClick={onClick}
              className="offset-control">
              <div className="hidden-text">
                Click to control offset
              </div>
            </div>
        );
    }

    return (
        <div className="offset-control">
          <ParameterBox stopPropagation={false} width={120} parameter={parameter} root={1.00001} />
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MicroOffsetControl);
